/**
 * @generated SignedSource<<7460231b5592da7d9f05c76745b68b29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SuggestedQuestions_Query$variables = Record<PropertyKey, never>;
export type SuggestedQuestions_Query$data = {
  readonly currentUser: {
    readonly suggestedQuestions: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SuggestedQuestionsList_Questions">;
    }> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SuggestedQuestionsList_User">;
  } | null | undefined;
};
export type SuggestedQuestions_Query = {
  response: SuggestedQuestions_Query$data;
  variables: SuggestedQuestions_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Video",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectReason",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestedQuestions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Question",
            "kind": "LinkedField",
            "name": "suggestedQuestions",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SuggestedQuestionsList_Questions"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SuggestedQuestionsList_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SuggestedQuestions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Question",
            "kind": "LinkedField",
            "name": "suggestedQuestions",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultMaxDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Answer",
                "kind": "LinkedField",
                "name": "textualAnswer",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textualAnswer",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Answer",
                "kind": "LinkedField",
                "name": "videoAnswer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoMaxDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoMinDuration",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "822fb478b973c4707a3a8baa151d0a67",
    "id": null,
    "metadata": {},
    "name": "SuggestedQuestions_Query",
    "operationKind": "query",
    "text": "query SuggestedQuestions_Query {\n  currentUser {\n    suggestedQuestions {\n      ...SuggestedQuestionsList_Questions\n      id\n    }\n    ...SuggestedQuestionsList_User\n    id\n  }\n}\n\nfragment AnswerListItemStatus_Video on Video {\n  id\n  status\n  rejectReason\n}\n\nfragment AnswerListItem_Question on Question {\n  rawId\n  id\n  title\n  textualAnswer {\n    id\n    textualAnswer\n  }\n  videoAnswer {\n    video {\n      ...AnswerListItem_Video\n      id\n    }\n    id\n  }\n}\n\nfragment AnswerListItem_User on User {\n  configuration {\n    videoMaxDuration\n    videoMinDuration\n  }\n  video {\n    ...AnswerListItem_Video\n    id\n  }\n}\n\nfragment AnswerListItem_Video on Video {\n  id\n  url\n  ...AnswerListItemStatus_Video\n}\n\nfragment QuestionAnswerListItem_Question on Question {\n  id\n  defaultMaxDuration\n  ...AnswerListItem_Question\n}\n\nfragment QuestionAnswerListItem_User on User {\n  configuration {\n    videoMaxDuration\n    videoMinDuration\n  }\n  ...AnswerListItem_User\n}\n\nfragment SuggestedQuestionsList_Questions on Question {\n  id\n  ...QuestionAnswerListItem_Question\n}\n\nfragment SuggestedQuestionsList_User on User {\n  ...QuestionAnswerListItem_User\n}\n"
  }
};
})();

(node as any).hash = "0ce2206e4c639415c410fb9f392877b3";

export default node;
